/**
 * src/config/glassTheme.js
 *
 * Shared "Level 2" glass material for VISINVOKE dashboard surfaces: a near-black
 * glossy body with the category colour washed richly through the top, a glossy
 * specular sheen, a glowing neon rim and glowing text. Identical formulas to the
 * top category buttons and header pills in components/ProductNav.js, so every
 * page's pills read as one system. Pass a category palette (deep, primary,
 * bright) from config/categoryTheme.js.
 */

export function viGlassRgb(hex) {
  var h = (hex || '#A347FF').replace('#', '');
  if (h.length === 3) { h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2]; }
  return parseInt(h.substring(0, 2), 16) + ', ' + parseInt(h.substring(2, 4), 16) + ', ' + parseInt(h.substring(4, 6), 16);
}

export function viGlassFill(d, p, br) {
  return 'linear-gradient(180deg, rgba(255,255,255,0.32) 0%, rgba(255,255,255,0.08) 30%, rgba(255,255,255,0) 54%), ' +
         'linear-gradient(180deg, rgba(' + viGlassRgb(p) + ',0.72) 0%, rgba(' + viGlassRgb(p) + ',0.30) 44%, rgba(' + viGlassRgb(d) + ',0.16) 74%, rgba(9,11,17,0) 100%), ' +
         'linear-gradient(180deg, #14171f 0%, #090b11 100%)';
}

export function viGlassShadow(d, p, br, strong) {
  if (strong) {
    return '0 0 30px rgba(' + viGlassRgb(p) + ',1), 0 0 62px rgba(' + viGlassRgb(p) + ',0.6), inset 0 0 28px rgba(' + viGlassRgb(p) + ',0.4), inset 0 1px 0 rgba(255,255,255,0.3), 0 10px 26px rgba(0,0,0,0.55)';
  }
  return '0 0 20px rgba(' + viGlassRgb(p) + ',0.8), 0 0 46px rgba(' + viGlassRgb(p) + ',0.45), inset 0 0 24px rgba(' + viGlassRgb(p) + ',0.28), inset 0 1px 0 rgba(255,255,255,0.28), 0 10px 26px rgba(0,0,0,0.55)';
}

export function viGlassTextGlow(br) {
  return '0 0 10px rgba(' + viGlassRgb(br) + ',0.9), 0 1px 4px rgba(0,0,0,0.6)';
}

export function viGlassBorder(br, width) {
  return (width || 1.5) + 'px solid rgba(' + viGlassRgb(br) + ',0.9)';
}

// Ready made Level 2 glass pill style for a category palette. Spread extra to
// override padding/size per page.
export function glassPill(pal, extra) {
  var p = pal || {};
  var base = {
    background: viGlassFill(p.deep, p.primary, p.bright),
    border: viGlassBorder(p.bright, 1.5),
    boxShadow: viGlassShadow(p.deep, p.primary, p.bright, false),
    color: '#fff',
    textShadow: viGlassTextGlow(p.bright),
    borderRadius: 999,
    padding: '7px 15px',
    fontSize: 13,
    fontWeight: 800,
  };
  if (extra) { for (var k in extra) { if (Object.prototype.hasOwnProperty.call(extra, k)) { base[k] = extra[k]; } } }
  return base;
}

// Full glass surface (background + rim + glow + glowing text) for one colour family.
export function glassSurface(d, p, br) {
  return {
    background: viGlassFill(d, p, br),
    border: viGlassBorder(br, 1.5),
    boxShadow: viGlassShadow(d, p, br, false),
    color: '#fff',
    textShadow: viGlassTextGlow(br),
  };
}
// Neon progress-bar fill (background + glow) for one colour family.
export function glassBarStyle(p, br, d) {
  var rp = viGlassRgb(p), rbr = viGlassRgb(br || p), rd = viGlassRgb(d || p);
  return {
    background: 'linear-gradient(180deg, rgba(255,255,255,0.5) 0%, rgba(' + rbr + ',0.95) 38%, rgba(' + rp + ',1) 60%, rgba(' + rd + ',1) 100%)',
    boxShadow: '0 0 8px rgba(' + rp + ',0.95), 0 0 16px rgba(' + rp + ',0.6), inset 0 1px 0 rgba(255,255,255,0.55)',
  };
}
